import { PATH } from '@/constants/path';
import { SECTION_SLOGANS, SECTION_TITLES } from '@/constants/products';
import useBestProductsHomeQuery from '@/hooks/RQHooks/market/best/useBestProductsHomeQuery';
import FeaturedSectionSkeleton from '../../../../components/common/FeaturedSectionSkeleton';
import SectionTitle from '../common/SectionTitle';
import FeaturedProductSection from './FeaturedProductSection';

const BestProductSection = () => {
  const { data, isPending } = useBestProductsHomeQuery();

  return (
    <div>
      <SectionTitle
        title={SECTION_TITLES.BEST_SELLERS}
        slogan={SECTION_SLOGANS.BEST_SELLERS}
        link={PATH.CATEGORY.BEST}
      />
      {isPending ? <FeaturedSectionSkeleton /> : <FeaturedProductSection data={data ?? []} />}
    </div>
  );
};

export default BestProductSection;
